// src/ConsumerApp/api/profile/profile.service.js
import { apiClient } from '../apiClient';

export const profileService = {
  getProfileDetails: async (customerId, token) => {
    if (!customerId) throw new Error('Customer ID is required');
    const response = await apiClient.get(
      `/brickbucket/customer/get-customer-by-customerId?customer_id=${customerId}`,
      {
        headers: token ? { 'x-token': token } : {},
      }
    );
    return response?.data || response;
  },

  updateProfileDetails: async (payload, token) => {
    const formData = new FormData();

    // 1. Mandatory customer identifier
    formData.append('_id', payload.id || payload._id);

    // 2. All string fields expected by UpdateCustomerfromProfilePage
    formData.append('customer_name', payload.name || '');
    formData.append('mobile_number', payload.mobile || '');
    formData.append('email', payload.email || '');
    formData.append('company_name', payload.companyName || '');
    formData.append('type_of_firm', payload.typeOfFirm || '');
    formData.append('gstin', payload.gstin || '');
    formData.append('pan', payload.pan || '');
    formData.append('city', payload.city || '');
    formData.append('state', payload.state || '');
    formData.append('association', payload.association || '');

    // 3. File upload (append under both 'file' and 'profile_image' to match multer)
    if (payload.imageFile instanceof File || payload.imageFile instanceof Blob) {
      formData.append('file', payload.imageFile);
      formData.append('profile_image', payload.imageFile);
    }

    // Call apiClient.put - apiClient will now preserve FormData without stringifying it
    const response = await apiClient.put(
      '/brickbucket/customer/update-customer-from-profilepage',
      formData,
      {
        headers: token ? { 'x-token': token } : {},
      }
    );

    return response?.data || response;
  },

  customerLogout: async (token) => {
    const response = await apiClient.post(
      '/brickbucket/customer/customer-logout',
      {},
      {
        headers: token ? { 'x-token': token } : {},
      }
    );
    return response?.data || response;
  },

  deleteCustomerAccount: async (payload, token) => {
    const response = await apiClient.post(
      '/brickbucket/customer/delete-customer-account',
      {
        customer_id: payload.customer_id,
        feedback: payload.feedback,
      },
      {
        headers: token ? { 'x-token': token } : {},
      }
    );
    return response?.data || response;
  },

 UpdateRigistrationData: async (payload, token) => {
    const response = await apiClient.put(
      '/brickbucket/customer/update-customer-from-profilepage',
      payload,
      {
        headers: token ? { 'x-token': token } : {},
      }
    );
    return response?.data || response;
  },
};